module.exports = __webpack_public_path__ + "img/img-10.d8f7073b.png";